// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6be2472d","513":"8343b983","703":"4cff7f81","722":"ea7d1c8a"}[chunkId] + ".chunk.js";
};